import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M8 11a4 4 0 1 1 8 0v5h-8l0 -5","key":"svg-0"}],["path",{"d":"M8 16v3a2 2 0 0 0 2 2h4a2 2 0 0 0 2 -2v-3","key":"svg-1"}],["path",{"d":"M9 4h6","key":"svg-2"}],["path",{"d":"M12 7v-3","key":"svg-3"}],["path",{"d":"M7 4a1 1 0 1 0 2 0a1 1 0 1 0 -2 0","key":"svg-4"}],["path",{"d":"M11.5 4a.5 .5 0 1 0 1 0a.5 .5 0 1 0 -1 0","fill":"currentColor","key":"svg-5"}]]

const IconScubaDivingTank = createReactComponent('outline', 'scuba-diving-tank', 'ScubaDivingTank', __iconNode);

export default IconScubaDivingTank;